import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import { Container, Row } from "react-bootstrap";
import axios from "../../utils/axios";
import useAuth from "../../hooks/useAuth";
import { useParams } from "react-router-dom";
import PaginationTable from "../../components/common/Table";

const Messages = () => {
  const [tableData, setTableData] = useState([]);
  const [title] = useState("Poslana obvestila");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { isAuthenticated } = useAuth();
  let { listId } = useParams();

  const currencyFormatter = new Intl.NumberFormat("sl-SI", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });

  const numberFormatter = new Intl.NumberFormat("sl-SI", {
    maximumFractionDigits: 0,
  });

  const tableColumns = [
    {
      Header: "Znamka",
      accessor: "ad.make",
    },
    {
      Header: "Model",
      accessor: "ad.model",
    },
    {
      Header: "Opis",
      accessor: "ad.title",
    },
    {
      Header: "Letnik",
      accessor: "ad.year",
    },
    {
      Header: "Kilometri",
      accessor: (d: any) => {
        if (!d.ad.kilometers) {
          return "/";
        }

        return numberFormatter.format(d.ad.kilometers);
      },
    },
    {
      Header: "Cena",
      accessor: (d: any) => {
        if (!d.ad.latestPrice) {
          return "/";
        }

        return currencyFormatter.format(d.ad.latestPrice);
      },
    },
    {
      Header: "Trgovec",
      accessor: (d: any) => {
        if (d.ad.ownerURL == null) {
          return "ne";
        }

        return "da";
      },
    },
    {
      Header: "Način",
      accessor: "alertChannel.type",
    },
    {
      Header: "Poslano",
      accessor: (d: any) => {
        return moment(d.createdAt).fromNow();
      },
    },
    // {
    //   Header: " ",
    //   accessor: (d: any) => {
    //     return (
    //       <Button
    //         variant="outline-secondary"
    //         className="float-end"
    //         onClick={() => {
    //         }}
    //       >
    //         Podrobnosti
    //       </Button>
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    setIsLoading(true);
    axios
      .get("/alerts/messages")
      .then((response) => {
        setTableData(response.data.alertMessages.rows);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [isAuthenticated, listId]);

  const onTrClick = (row: any) => {
    const win = window.open(row.original.ad.url, "_blank");
    if (win != null) {
      win.focus();
    }
  };

  return (
    <React.Fragment>
      <Helmet title="Obveščanje" />
      <Container fluid className="p-0">
        <Row>
          <h1 className="h3 mb-3">{title}</h1>
        </Row>
        <PaginationTable
          isLoading={isLoading}
          columns={tableColumns}
          data={tableData}
          onTrClick={onTrClick}
        />
      </Container>
    </React.Fragment>
  );
};

export default Messages;
